/** Adds the Vuelidate validation messages in the internationalisation plugin */
import { Ref } from "vue";
import * as validators from "@vuelidate/validators";
import i18n from "@/plugins/vi18n";

const { createI18nMessage } = validators;

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) });
export const required = withI18nMessage(validators.required);
export const minLength = withI18nMessage(validators.minLength, {
    withArguments: true,
});
export const maxLength = withI18nMessage(validators.maxLength, {
    withArguments: true,
});
export const email = withI18nMessage(validators.email);

export const numeric = withI18nMessage(validators.numeric);

export const getMessageFromI18nList = (stringToCheck: string | Ref<string>) => {
    return (stringToCheck as string).startsWith("validations.");
};
